import { useProfileQuery } from 'v2/pages/settings/queries'

// Per-tab latch: the first `true` seen for an org wins over any later stale `false` a
// sibling tab replays via broadcastQueryClient (SER-6449) — see pages/AGENTS.md.

const STORAGE_KEY = 'onboarding_completed_org'

// Both guards: blocked storage can throw on access or on the method, and the read runs
// during OnboardingGate's render — degrade to the cached flag, never crash the layout.
export const latchOnboardingCompleted = (orgId: string | undefined) => {
  try {
    if (orgId) sessionStorage.setItem(STORAGE_KEY, orgId)
  } catch {
    // storage unavailable: the gate falls back to the cached flag
  }
}

export const isOnboardingLatched = (orgId: string | undefined): boolean => {
  try {
    return !!orgId && sessionStorage.getItem(STORAGE_KEY) === orgId
  } catch {
    return false
  }
}

export const useOnboardingCompleted = () => {
  const { data: profile, isLoading } = useProfileQuery()
  const org = profile?.organizations?.[0]
  // Latched during render: an effect could run after a stale replay has already landed.
  if (org?.onboarding_completed === true) latchOnboardingCompleted(org.org_id)
  // `undefined` passes through so the gate keeps failing open on absent data.
  return {
    completed: isOnboardingLatched(org?.org_id) ? true : org?.onboarding_completed,
    isLoading,
  }
}
